import {decimal} from "../../Function/globalFunction";

export function headers(intl, active_year, isShiftDuty) {
    const year = active_year;
    let data = [
        {label: intl.formatMessage({id: 'leave_approval.staff_number'}), key: "staffNo"},
        {label: intl.formatMessage({id: 'leave_approval.employee'}), key: "employeeName"},
        {label: intl.formatMessage({id: 'leave_approval.position'}), key: "position"},
        {label: intl.formatMessage({id: 'leave_approval.location'}), key: "location"},
        {label: intl.formatMessage({id: 'leave_approval.department'}), key: "department"},
    ]

    for (let i = 2; i >= 0; i--) {
        data.push(
            {label: year[i] + intl.formatMessage({id: 'myteam.annual_leave_total'}), key: 'total_' + year[i]},
            {label: year[i] + intl.formatMessage({id: 'myteam.annual_leave_taken'}), key: 'taken_' + year[i]},
            {label: year[i] + intl.formatMessage({id: 'myteam.annual_leave_balance'}), key: 'balance_' + year[i]},
            {label: year[i] + intl.formatMessage({id: 'myteam.annual_leave_expiry_date'}), key: 'expiry_date_' + year[i]},
        )
    }

    // For Comp Leave Balance
    data.push({label: intl.formatMessage({id: 'comp_leave.comp_leave_balance_hours'}), key: "compLeaveBalance"});

    return data;
}

export function data(csvData, isShiftDuty) {
    const annualAllowances = csvData.annual_allowances

    let data = {
        employeeName: `${csvData.employee_name}`,
        staffNo: `${csvData.staff_no}`,
        position: `${csvData.position}`,
        location: `${csvData.location ? csvData.location.name : ''}`,
        department: `${csvData.department ? csvData.department.name : ''}`,
    }

    // For Comp Leave Balance
    data = {...data, ...{compLeaveBalance: `${csvData.comp_leave_balance && csvData.staff_no != '000001' ? csvData.comp_leave_balance : ''}`}};

    for (let i = 0; i < 3; i++) {
        if (annualAllowances[i]) {
            data['total_' + annualAllowances[i].year] = decimal(annualAllowances[i].total);
            data['taken_' + annualAllowances[i].year] = decimal(annualAllowances[i].taken);
            data['balance_' + annualAllowances[i].year] = decimal(annualAllowances[i].balance);
            data['expiry_date_' + annualAllowances[i].year] = annualAllowances[i].expiry_date;
        }
    }

    return data;
}
